// SEO-landingspagina's — unieke, keyword-rijke content per onderwerp (regio Torhout, West-Vlaanderen).

const CTA = { label: "Maak een afspraak", to: "/afspraak" };

export const seoPages = {
  "motoronderhoud": {
    slug: "motoronderhoud",
    seoTitle: "Motoronderhoud Torhout | Onderhoud motorfiets alle merken — TT Motorsports",
    metaDescription:
      "Professioneel motoronderhoud in Torhout voor alle merken en types motoren. Kleine en grote beurten, olie, filters, ketting en remmen. Boek je onderhoud motorfiets bij TT Motorsports.",
    keywords:
      "motor onderhoud, onderhoud motorfiets, motoronderhoud Torhout, motor garage, motor specialist, motor onderhoud in de buurt, TT Motorsports",
    h1: "Motoronderhoud in Torhout — voor alle merken en types motoren",
    intro: [
      "Regelmatig motoronderhoud is de sleutel tot een betrouwbare, veilige en zuinige motor. Bij TT Motorsports in Torhout verzorgen we het onderhoud van je motorfiets volgens de fabrieksvoorschriften, ongeacht merk of type. Van crossmotor tot sportmotor en touringmotor: iedere motorrijder is bij ons aan het juiste adres.",
      "Als motor specialist in de regio West-Vlaanderen combineren we jarenlange technische ervaring met eerlijk advies. Zo weet je altijd exact welk onderhoud je motor nodig heeft — zonder verrassingen.",
    ],
    sections: [
      {
        h2: "Wat houdt een onderhoudsbeurt in?",
        body: [
          "Een volledige onderhoudsbeurt omvat onder meer een olie- en filterservice, controle en smering van de ketting, nazicht van de remmen en remvloeistof, controle van de banden en bandenspanning, en een grondige inspectie van de veiligheidskritische onderdelen.",
        ],
        list: [
          "Kleine en grote onderhoudsbeurten",
          "Olie verversen & oliefilter vervangen",
          "Ketting, tandwielen en aandrijving",
          "Remmen, remblokken en remvloeistof",
          "Banden, bandenspanning en balancering",
          "Volledige veiligheidscontrole",
        ],
      },
      {
        h2: "Onderhoud voor elk type motor",
        body: [
          "Wij voeren onderhoud uit op crossmotoren, enduromotoren, baanmotoren, sportmotoren, naked bikes, touringmotoren, adventuremotoren, supermoto's en scooters. Zowel offroad als baanmotoren krijgen bij ons de vakkundige aanpak die ze verdienen.",
          "Zoek je 'motor onderhoud in de buurt' of een betrouwbare motor garage in de regio Torhout? Dan ben je bij TT Motorsports op de juiste plek.",
        ],
      },
    ],
    image: {
      url: "https://images.unsplash.com/photo-1762604462286-472334549804",
      alt: "Motoronderhoud in de werkplaats van TT Motorsports in Torhout",
    },
    related: ["motorherstellingen", "crossmotor-onderhoud", "motoronderdelen"],
    cta: CTA,
  },

  "motorherstellingen": {
    slug: "motorherstellingen",
    seoTitle: "Motorherstellingen & motor reparatie Torhout — alle merken | TT Motorsports",
    metaDescription:
      "Motor herstelling en reparatie in Torhout voor alle merken en types. Van kleine defecten tot volledige revisie. Snel, vakkundig en eerlijk bij TT Motorsports — jouw motor specialist in de regio.",
    keywords:
      "motor herstelling, motor reparatie, motorherstellingen Torhout, motor herstelling nabij, motor garage, motor specialist, TT Motorsports",
    h1: "Motorherstellingen en reparatie in Torhout",
    intro: [
      "Een defect aan je motor? Bij TT Motorsports voeren we motorherstellingen uit van alle merken en types. Of het nu gaat om een kleine reparatie of een volledige motorblokrevisie, onze technici brengen je motor snel en betrouwbaar weer op de baan.",
      "Als motor specialist in Torhout en omstreken staan we bekend om eerlijke diagnoses en kwalitatieve herstellingen met de juiste onderdelen.",
    ],
    sections: [
      {
        h2: "Welke herstellingen voeren wij uit?",
        body: [
          "Van motorblok en versnellingsbak tot ophanging, remmen en elektronica: wij pakken elke motor reparatie professioneel aan. We werken met originele en hoogwaardige aftermarket onderdelen voor een duurzaam resultaat.",
        ],
        list: [
          "Motorblok- en versnellingsbakrevisie",
          "Ophanging en vering",
          "Remsystemen",
          "Elektrische storingen en bedrading",
          "Bandenwissel en balanceren",
          "Schadeherstelling",
        ],
      },
      {
        h2: "Zoek je 'motor herstelling nabij'?",
        body: [
          "TT Motorsports is jouw vertrouwde motor garage in de regio West-Vlaanderen. Ligt je motorfiets stil of merk je een storing op? Neem contact op of maak online een afspraak — we helpen je snel verder.",
        ],
      },
    ],
    image: {
      url: "https://images.pexels.com/photos/11536993/pexels-photo-11536993.jpeg",
      alt: "Technicus voert een motorherstelling uit bij TT Motorsports Torhout",
    },
    related: ["motoronderhoud", "motoronderdelen", "baanmotor-onderhoud"],
    cta: CTA,
  },

  "crossmotor-onderhoud": {
    slug: "crossmotor-onderhoud",
    seoTitle: "Crossmotor onderhoud & herstelling Torhout — MX specialist | TT Motorsports",
    metaDescription:
      "Crossmotor onderhoud en herstelling in Torhout. Motorrevisie, ophanging, kleppen en meer voor jouw MX-motor. TT Motorsports is dé crossmotor specialist in West-Vlaanderen.",
    keywords:
      "crossmotor onderhoud, crossmotor herstelling, MX onderhoud, motocross onderhoud Torhout, crossmotor specialist, TT Motorsports",
    h1: "Crossmotor onderhoud en herstelling",
    intro: [
      "Motorcross vraagt veel van je machine. Daarom is regelmatig crossmotor onderhoud essentieel om je MX-motor betrouwbaar en snel te houden. Bij TT Motorsports in Torhout zijn we gespecialiseerd in het onderhoud en de herstelling van crossmotoren van alle merken.",
      "Van luchtfilter en olie tot kleppencontrole en zuigerrevisie: wij houden je crossmotor in topconditie, klaar voor de volgende training of wedstrijd.",
    ],
    sections: [
      {
        h2: "Specialistisch onderhoud voor motocross",
        body: [
          "Een crossmotor draait op hoge toeren en verdient een gerichte aanpak. Wij verzorgen periodiek onderhoud, motorrevisies en afstellingen zodat jij het maximale uit je machine haalt.",
        ],
        list: [
          "Zuiger- en cilinderrevisie",
          "Kleppen controleren en afstellen",
          "Luchtfilter en olieservice",
          "Ophanging reviseren en afstellen",
          "Ketting, tandwielen en remmen",
        ],
      },
      {
        h2: "Ook voor enduro en offroad",
        body: [
          "Naast cross verzorgen we ook enduro onderhoud en herstellingen. Zowel offroad- als baanmotoren zijn welkom in onze werkplaats in Torhout.",
        ],
      },
    ],
    image: {
      url: "https://images.pexels.com/photos/32253340/pexels-photo-32253340.jpeg",
      alt: "Crossmotor klaar voor onderhoud bij TT Motorsports",
    },
    related: ["enduro-onderhoud", "motoronderhoud", "motoronderdelen"],
    cta: CTA,
  },

  "enduro-onderhoud": {
    slug: "enduro-onderhoud",
    seoTitle: "Enduro onderhoud & herstelling Torhout — offroad specialist | TT Motorsports",
    metaDescription:
      "Enduro onderhoud en herstelling in Torhout voor alle merken. Van motorrevisie tot ophanging en elektronica. TT Motorsports is jouw enduro en offroad specialist in West-Vlaanderen.",
    keywords:
      "enduro onderhoud, enduro herstelling, offroad motor onderhoud, enduromotor Torhout, motor specialist, TT Motorsports",
    h1: "Enduro onderhoud en herstelling",
    intro: [
      "Enduromotoren worden onder zware omstandigheden gebruikt. Goed enduro onderhoud is dan ook onmisbaar voor prestaties en betrouwbaarheid. Bij TT Motorsports in Torhout onderhouden en herstellen we enduromotoren van alle merken.",
      "Onze technici kennen de eisen van het offroad-rijden en zorgen ervoor dat je motor altijd klaar is voor het volgende avontuur.",
    ],
    sections: [
      {
        h2: "Compleet onderhoud voor je enduromotor",
        body: [
          "Wij verzorgen alles van olieservice en luchtfilter tot motorrevisie, ophanging en elektronica. Zo blijft je enduromotor betrouwbaar in de meest veeleisende terreinen.",
        ],
        list: [
          "Motor- en cilinderrevisie",
          "Ophanging afstellen en reviseren",
          "Luchtfilter en olieservice",
          "Elektronica en verlichting",
          "Banden en remmen",
        ],
      },
      {
        h2: "Van offroad tot baanmotor",
        body: [
          "TT Motorsports werkt niet enkel aan enduro en cross, maar aan alle types motoren — ook baanmotoren, sportmotoren en touringmotoren. Professionele service voor iedere motorrijder in de regio.",
        ],
      },
    ],
    image: {
      url: "https://images.pexels.com/photos/8532384/pexels-photo-8532384.png",
      alt: "Enduromotor in de werkplaats van TT Motorsports Torhout",
    },
    related: ["crossmotor-onderhoud", "motorherstellingen", "motoronderhoud"],
    cta: CTA,
  },

  "baanmotor-onderhoud": {
    slug: "baanmotor-onderhoud",
    seoTitle: "Baanmotor & sportmotor onderhoud Torhout — alle merken | TT Motorsports",
    metaDescription:
      "Baanmotor onderhoud en sportmotor onderhoud in Torhout. Onderhoud en herstelling voor naked bikes, sportmotoren, touring- en adventuremotoren. TT Motorsports, jouw motor specialist.",
    keywords:
      "baanmotor onderhoud, sportmotor onderhoud, naked bike onderhoud, touringmotor onderhoud, motor garage Torhout, TT Motorsports",
    h1: "Baanmotor- en sportmotor onderhoud",
    intro: [
      "Ook voor baanmotoren ben je bij TT Motorsports aan het juiste adres. Wij verzorgen baanmotor onderhoud en sportmotor onderhoud in Torhout voor alle merken en modellen.",
      "Sportmotoren, naked bikes, touringmotoren, adventuremotoren en supermoto's: wij zorgen voor vakkundig onderhoud zodat je veilig en zorgeloos de baan opgaat.",
    ],
    sections: [
      {
        h2: "Onderhoud op maat van je baanmotor",
        body: [
          "Van periodieke onderhoudsbeurten tot herstellingen: wij houden je baanmotor in perfecte staat. We werken volgens fabrieksvoorschriften en gebruiken kwalitatieve onderdelen.",
        ],
        list: [
          "Grote en kleine onderhoudsbeurten",
          "Olie, filters en vloeistoffen",
          "Remmen en banden",
          "Elektronica en diagnose",
          "Keuringklaar maken",
        ],
      },
      {
        h2: "Alle types motoren welkom",
        body: [
          "TT Motorsports is niet enkel gespecialiseerd in cross- en enduromotoren. Wij bieden service voor zowel offroad als baanmotoren — voor iedere motorrijder in Torhout en de ruime regio West-Vlaanderen.",
        ],
      },
    ],
    image: {
      url: "https://images.unsplash.com/photo-1769537754949-65dcaa720995",
      alt: "Sportmotor / baanmotor bij TT Motorsports Torhout",
    },
    related: ["motoronderhoud", "motorherstellingen", "tweedehands-motoren"],
    cta: CTA,
  },

  "tweedehands-motoren": {
    slug: "tweedehands-motoren",
    seoTitle: "Tweedehands motoren te koop Torhout — gebruikte motor kopen | TT Motorsports",
    metaDescription:
      "Tweedehands motoren te koop in Torhout. Gekeurde gebruikte motoren van alle merken, gecontroleerd in eigen werkplaats. Gebruikte motor kopen doe je bij TT Motorsports in de regio West-Vlaanderen.",
    keywords:
      "tweedehands motoren, motoren te koop, gebruikte motor kopen, tweedehands motoren regio, occasie motor, TT Motorsports Torhout",
    h1: "Tweedehands motoren te koop in Torhout",
    intro: [
      "Op zoek naar een betrouwbare tweedehands motor? Bij TT Motorsports vind je een aanbod van gekeurde gebruikte motoren van verschillende merken. Elke occasie wordt in onze eigen werkplaats in Torhout grondig gecontroleerd en klaargemaakt voor de baan.",
      "Of je nu een gebruikte motor wil kopen voor cross, enduro, de baan of dagelijks gebruik: wij helpen je met eerlijk advies bij het vinden van de juiste machine.",
    ],
    sections: [
      {
        h2: "Waarom een gebruikte motor kopen bij TT Motorsports?",
        body: [
          "Elke tweedehands motor wordt technisch nagekeken en indien nodig onderhouden voor verkoop. Zo koop je met een gerust hart. We voorzien duidelijke informatie over bouwjaar, kilometerstand, onderhoudshistoriek en opties.",
        ],
        list: [
          "Gekeurde en gecontroleerde occasies",
          "Alle merken en types motoren",
          "Onderhoudshistoriek beschikbaar",
          "Eerlijk en persoonlijk advies",
          "Inruil bespreekbaar",
        ],
      },
      {
        h2: "Bekijk ons actueel aanbod",
        body: [
          "Ons aanbod tweedehands motoren wordt regelmatig aangevuld. Bekijk de beschikbare motoren online en filter eenvoudig op merk, bouwjaar, prijs en kilometerstand.",
        ],
      },
    ],
    image: {
      url: "https://images.unsplash.com/photo-1773940792913-94baf5fa0130",
      alt: "Tweedehands motoren te koop bij TT Motorsports Torhout",
    },
    related: ["motoronderhoud", "motoronderdelen", "motorherstellingen"],
    cta: { label: "Bekijk onze tweedehands motoren", to: "/motoren" },
  },

  "motoronderdelen": {
    slug: "motoronderdelen",
    seoTitle: "Motoronderdelen Torhout — originele & aftermarket onderdelen | TT Motorsports",
    metaDescription:
      "Motoronderdelen voor alle merken in Torhout. Originele en aftermarket onderdelen, snel besteld en vakkundig gemonteerd. TT Motorsports levert motoronderdelen voor cross, enduro en baanmotoren.",
    keywords:
      "motoronderdelen, motor onderdelen, originele motoronderdelen, aftermarket onderdelen, motoronderdelen Torhout, TT Motorsports",
    h1: "Motoronderdelen voor alle merken",
    intro: [
      "Bij TT Motorsports in Torhout vind je motoronderdelen voor nagenoeg elk merk en type motor. We bieden zowel originele als kwalitatieve aftermarket onderdelen, met advies op maat en vakkundige montage in onze werkplaats.",
      "Van slijtonderdelen tot revisiesets: wij bestellen snel en zorgen dat je motor weer piekfijn presteert.",
    ],
    sections: [
      {
        h2: "Ons aanbod motoronderdelen",
        body: [
          "Zoek je een specifiek onderdeel voor je crossmotor, enduromotor of baanmotor? Wij helpen je aan het juiste onderdeel en monteren het desgewenst meteen.",
        ],
        list: [
          "Remblokken, remschijven en kettingen",
          "Filters, bougies en vloeistoffen",
          "Plastic kits en carrosserie",
          "Ophanging en motoronderdelen",
          "Revisiesets op aanvraag",
        ],
      },
      {
        h2: "Onderdelen inclusief montage",
        body: [
          "Wij leveren niet alleen motoronderdelen, we monteren ze ook vakkundig. Zo ben je zeker van een correcte en veilige montage. Vraag gerust naar de mogelijkheden.",
        ],
      },
    ],
    image: {
      url: "https://images.unsplash.com/photo-1650569663281-44a28c984e2a",
      alt: "Motoronderdelen en motorblok bij TT Motorsports Torhout",
    },
    related: ["motoronderhoud", "motoronderdelen", "tweedehands-motoren"],
    cta: { label: "Bekijk onze onderdelen", to: "/onderdelen" },
  },
};

export const seoPageList = Object.values(seoPages).map((p) => ({
  slug: p.slug,
  title: p.h1,
}));
